import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import s from './FormBackButton.css';

const FormBackButton = ({onClick}) => {
    return (
        <div className={s.component}>
            <nav className={s.container}>
                <button
                    type="button"
                    className={cx(s.backButton)}
                    onClick={onClick}
                />
                <h1 className={s.label}>Forms</h1>
            </nav>
        </div>
    );
};

FormBackButton.propTypes = {
    onClick: PropTypes.func,
};

export default FormBackButton;


// WEBPACK FOOTER //
// ./src/components/Pages/Forms/PrivateForms/FormButtons/FormBackButton/FormBackButton.js